import { ICalculatedBasket, IFlowPickup, IFlowSend, IGiftShopToBasketBundle } from '$models';

export const getDefaultBundle = (itemNumber?: string) => {
    const bundle: IGiftShopToBasketBundle = {
        giftShopProducts: [
            {
                description: undefined,
                isInternalItem: false,
                itemNumber: itemNumber,
                quantity: 1,
            },
        ],
        giftDetails: {
            deliveryAddress: {
                att: undefined,
                name: undefined,
                companyName: undefined,
                streetAndNumber: undefined,
                zip: undefined,
                city: undefined,
                leaveAtDoor: undefined,
                phoneNumber: undefined,
            },
            deliveryDate: undefined,
            pickupDate: undefined,
            storeId: undefined,
            cardResourceId: undefined,
            storeNotified: false,
            occasion: undefined,
        },
    };
    return bundle;
};

export const getBundleFromBasket = (basket?: ICalculatedBasket) => {
    const bundle: IGiftShopToBasketBundle = {
        giftShopProducts: basket?.lines
            ?.filter((line) => line?.isGiftShopItem)
            .map((line) => ({
                description: line?.description,
                isInternalItem: false,
                itemNumber: line?.product?.itemNumber,
                quantity: line?.quantity,
            })),
        giftDetails: {
            deliveryAddress: basket?.sameDayDeliveryDetails?.deliveryAddress,
            deliveryDate: basket?.sameDayDeliveryDetails?.shippingType
                ? basket?.sameDayDeliveryDetails?.deliveryDate
                : undefined,
            pickupDate: basket?.sameDayDeliveryDetails?.shippingType
                ? basket?.sameDayDeliveryDetails?.deliveryDate
                : undefined,
            storeId: basket?.sameDayDeliveryDetails?.storeId,
            storeNotified: false,
        },
    };

    return bundle;
};

export const addDeliveryStepToBundle = (data: IFlowSend | IFlowPickup, bundle?: IGiftShopToBasketBundle) => {
    if (!bundle) {
        return bundle;
    }
    const newBundle: IGiftShopToBasketBundle = { ...bundle };
    if (!newBundle.giftDetails) {
        return newBundle;
    }
    if (data.kind === 'send') {
        if (!newBundle.giftDetails.deliveryAddress) {
            return newBundle;
        }
        newBundle.giftDetails.deliveryAddress.name = data.name;
        newBundle.giftDetails.deliveryAddress.companyName = data.companyName;
        newBundle.giftDetails.deliveryAddress.streetAndNumber = data.address;
        newBundle.giftDetails.deliveryAddress.zip = data.zipcode;
        newBundle.giftDetails.deliveryAddress.city = data.city;
        newBundle.giftDetails.deliveryAddress.phoneNumber = data.phoneNumber;
        newBundle.giftDetails.deliveryAddress.leaveAtDoor = true;
        newBundle.giftDetails.deliveryDate = data.deliveryDate;
        newBundle.giftDetails.storeId = data.storeId;
    } else {
        newBundle.giftDetails.storeId = data.storeId;
        newBundle.giftDetails.pickupDate = data.pickupDate;
    }

    if (data.occasion) {
        newBundle.giftDetails.occasion = data.occasion;
    }

    return newBundle;
};

export const editDeliveryStep = (data: IFlowSend | IFlowPickup, bundle?: IGiftShopToBasketBundle) => {
    if (!bundle) {
        return bundle;
    }

    const newBundle: IGiftShopToBasketBundle = { ...bundle };

    if (!newBundle.giftDetails?.deliveryAddress) {
        return newBundle;
    }
    if (data.kind === 'send') {
        newBundle.giftDetails.deliveryAddress.name =
            newBundle.giftDetails.deliveryAddress.name !== data.name
                ? data.name
                : newBundle.giftDetails.deliveryAddress.name;
        newBundle.giftDetails.deliveryAddress.companyName =
            newBundle.giftDetails.deliveryAddress.companyName !== data.companyName
                ? data.companyName
                : newBundle.giftDetails.deliveryAddress.companyName;
        newBundle.giftDetails.deliveryAddress.streetAndNumber =
            newBundle.giftDetails.deliveryAddress.streetAndNumber !== data.address
                ? data.address
                : newBundle.giftDetails.deliveryAddress.streetAndNumber;
        newBundle.giftDetails.deliveryAddress.zip =
            newBundle.giftDetails.deliveryAddress.zip !== data.zipcode
                ? data.zipcode
                : newBundle.giftDetails.deliveryAddress.zip;
        newBundle.giftDetails.deliveryAddress.city =
            newBundle.giftDetails.deliveryAddress.city !== data.city
                ? data.city
                : newBundle.giftDetails.deliveryAddress.city;
        newBundle.giftDetails.deliveryAddress.phoneNumber =
            newBundle.giftDetails.deliveryAddress.phoneNumber !== data.phoneNumber
                ? data.phoneNumber
                : newBundle.giftDetails.deliveryAddress.phoneNumber;
        newBundle.giftDetails.deliveryDate =
            newBundle.giftDetails.deliveryDate !== data.deliveryDate
                ? data.deliveryDate
                : newBundle.giftDetails.deliveryDate;
        newBundle.giftDetails.storeId =
            newBundle.giftDetails.storeId !== data.storeId ? data.storeId : newBundle.giftDetails.storeId;
        newBundle.giftDetails.pickupDate = undefined;
        newBundle.giftDetails.deliveryAddress.leaveAtDoor = true;
    } else {
        newBundle.giftDetails.deliveryAddress.name = undefined;
        newBundle.giftDetails.deliveryAddress.companyName = undefined;
        newBundle.giftDetails.deliveryAddress.streetAndNumber = undefined;
        newBundle.giftDetails.deliveryAddress.zip = undefined;
        newBundle.giftDetails.deliveryAddress.city = undefined;
        newBundle.giftDetails.deliveryAddress.phoneNumber = undefined;
        newBundle.giftDetails.deliveryAddress.leaveAtDoor = undefined;
        newBundle.giftDetails.deliveryDate = undefined;
        newBundle.giftDetails.storeId =
            newBundle.giftDetails.storeId !== data.storeId ? data.storeId : newBundle.giftDetails.storeId;
        newBundle.giftDetails.pickupDate =
            newBundle.giftDetails.pickupDate !== data.pickupDate ? data.pickupDate : newBundle.giftDetails.pickupDate;
    }
    newBundle.giftDetails.occasion =
        newBundle.giftDetails.occasion !== data.occasion ? data.occasion : newBundle.giftDetails.occasion;

    return newBundle;
};
